/**
 * @see https://github.com/danwild/leaflet-velocity
 */
import Windy from './Windy'
import './L.Control.Velocity'
/**
 * 
 */
L.VelocityLayer = L.Layer.extend({//L.Class.extend
	options: {
		displayValues: true,
		displayOptions: {
			velocityType: 'Velocity',
			position: 'bottomleft',
			emptyString: 'No velocity data'
		},
		maxVelocity: 10, // used to align color scale
		colorScale: null,
		data: null
	},
	// _map: null,
	// _canvasLayer: null,
	// _windy: null,
	// _context: null,
	// _mouseControl: null, //底部风力信息
	_timer: 0,

	initialize: function (options) {
		L.setOptions(this, options);
		this.ajax = T.one(url => T.ajax({ f: 'json', url: url, success: data => { this.setData(data) } }))
	},

	onAdd: function (map) {
		// create canvas, add overlay control
		this._canvasLayer = L.canvasLayer().delegate(this);
		this._canvasLayer.addTo(map);
		this._map = map;
	},

	onRemove: function (map) {
		this._destroyWind();
	},

	setData: function setData(data) {
		this.options.data = data;

		if (this._windy) {
			this._windy.setData(data);
			this._clearAndRestart();
		}

		this.fire('load');
	},

	onDrawLayer: function (overlay, params) {
		let self = this,
			{ _windy, options, _timer } = self;
		if (!this._windy) {
			this._initWindy(self);
			return;
		}
		let { data, url } = options;
		if (!data) {
			url && this.ajax(url)
			return;
		}

		if (_timer) clearTimeout(_timer);

		this._timer = setTimeout(function () {
			self._startWindy();
		}, 750);
	},

	_startWindy: function () {
		var bounds = this._map.getBounds();
		var size = this._map.getSize();

		// bounds, width, height, extent
		this._windy.start(
			[
				[0, 0],
				[size.x, size.y]
			],
			size.x,
			size.y,
			[
				[bounds._southWest.lng, bounds._southWest.lat],
				[bounds._northEast.lng, bounds._northEast.lat]
			]);
	},

	_initWindy: function (self) {
		this._windy = new Windy(T.assign({ canvas: self._canvasLayer._canvas }, self.options));

		// prepare context global var, start drawing
		this._context = this._canvasLayer._canvas.getContext('2d');
		this._canvasLayer._canvas.classList.add("velocity-overlay");
		this.onDrawLayer();

		this._map.on('dragstart', self._windy.stop)
			.on('dragend', self._clearAndRestart)
			.on('zoomstart', self._windy.stop)
			.on('zoomend', self._clearAndRestart)
			.on('resize', self._clearWind);

		this._initMouseHandler();
	},

	_initMouseHandler: function () {
		if (!this._mouseControl && this.options.displayValues) {
			var options = this.options.displayOptions || {};
			options['leafletVelocity'] = this;
			this._mouseControl = L.control.velocity(options).addTo(this._map);
		}
	},

	_clearAndRestart: function () {
		if (this._context) this._context.clearRect(0, 0, 3000, 3000);
		if (this._windy) this._startWindy();
	},

	_clearWind: function () {
		if (this._windy) this._windy.stop();
		if (this._context) this._context.clearRect(0, 0, 3000, 3000);
	},

	_destroyWind: function () {
		if (this._timer) clearTimeout(this._timer);
		if (this._windy) this._windy.stop();
		if (this._context) this._context.clearRect(0, 0, 3000, 3000);
		if (this._mouseControl) this._map.removeControl(this._mouseControl);
		this._mouseControl = null;
		this._windy = null;
		this._map.removeLayer(this._canvasLayer);
	}
});

L.velocityLayer = function (options) {
	return new L.VelocityLayer(options);
};


// WEBPACK FOOTER //
// ./src/plugins/velocity/L.VelocityLayer.js